<ion-modal [isOpen]="nyitva" (didDismiss)="bezar.emit()" cssClass="sorablak-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Szűkítés</ion-title></ion-toolbar></ion-header>
    <div class="sa-torzs">
      <div class="sa szk" (keydown.enter)="enter($event)">
        <div class="szk-jelolok" *ngIf="mod === 'kivonat'">
          <label><input type="checkbox" [(ngModel)]="s.deviza_ertek" (ngModelChange)="igazit('deviza_ertek')">
            Deviza értékek feltüntetése</label>
          <label [title]="s.deviza_ertek ? 'Deviza értékek mellett nem kérhető' : 'Nyolc oszlop: Nyitó · Forgalom · Forgalom egyenleg · Összesen egyenleg. A dátum-intervallum előtti tételek a Nyitóba kerülnek.'">
            <input type="checkbox" [(ngModel)]="s.elozo" [disabled]="s.deviza_ertek" (ngModelChange)="igazit('elozo')">
            Előző időszak megjelenítése</label>
          <label class="behuzott">
            <input type="checkbox" [(ngModel)]="s.elozo_nyito" [disabled]="!s.elozo || s.deviza_ertek">
            Nyitó napló tételei szerepeljenek az előző időszak összesítésében</label>
          <label title="A vevő és szállító számlák (a Könyvelési beállításokban kijelöltek) partnerkóddal alábontva: 311 → 31100001">
            <input type="checkbox" [(ngModel)]="s.partner_bontas" (ngModelChange)="igazit('partner_bontas')">
            Vevő-szállító számlák alábontása partnerenként</label>
          <label [title]="s.msz_nelkul ? 'Munkaszám nélküli tételeknél nincs mire bontani' : 'Egyszerre csak az egyik alábontás kérhető'">
            <input type="checkbox" [(ngModel)]="s.munkaszam_bontas" [disabled]="s.msz_nelkul" (ngModelChange)="igazit('munkaszam_bontas')">
            Főkönyvi szám (5-9) alábontása munkaszámonként</label>
        </div>

        <div class="szk-racs">
          <ng-container *ngIf="van('datum')">
            <span>Dátum</span>
            <input type="date" max="9999-12-31" [(ngModel)]="s.tol"><span class="kozep">–</span><input type="date" max="9999-12-31" [(ngModel)]="s.ig">
          </ng-container>

          <ng-container *ngIf="van('szamla')">
            <span>Főkönyvi szám</span>
            <span class="szk-mezo"><input type="text" class="kod" [(ngModel)]="s.szamla" list="szkSzlaLista" maxlength="12">
              <button type="button" class="szk-val" (click)="valasztoNyit('szamla', 'szamla')" title="Választás a számlatükörből"><ion-icon name="caret-forward"></ion-icon></button></span>
            <span></span>
            <select [(ngModel)]="s.szamla_op"><option *ngFor="let o of illeszkedesek" [value]="o.v">{{ o.c }}</option></select>

            <span>Fők.sz. intervallum</span>
            <span class="szk-mezo"><input type="text" class="kod" [(ngModel)]="s.szamla_tol" list="szkSzlaLista" maxlength="12">
              <button type="button" class="szk-val" (click)="valasztoNyit('szamla', 'szamla_tol')" title="Választás a számlatükörből"><ion-icon name="caret-forward"></ion-icon></button></span>
            <span class="kozep">–</span>
            <span class="szk-mezo"><input type="text" class="kod" [(ngModel)]="s.szamla_ig" list="szkSzlaLista" maxlength="12">
              <button type="button" class="szk-val" (click)="valasztoNyit('szamla', 'szamla_ig')" title="Választás a számlatükörből"><ion-icon name="caret-forward"></ion-icon></button></span>
          </ng-container>

          <ng-container *ngIf="van('munkaszam')">
            <span>Munkaszám</span>
            <span class="szk-mezo"><input type="text" class="kod" [(ngModel)]="s.munkaszam" [disabled]="s.msz_nelkul" list="szkMszLista" maxlength="10">
              <button type="button" class="szk-val" [disabled]="s.msz_nelkul" (click)="valasztoNyit('munkaszam', 'munkaszam')" title="Választás a munkaszám-törzsből"><ion-icon name="caret-forward"></ion-icon></button></span>
            <span></span>
            <select [(ngModel)]="s.munkaszam_op" [disabled]="s.msz_nelkul"><option *ngFor="let o of illeszkedesek" [value]="o.v">{{ o.c }}</option></select>

            <span>Msz. intervallum</span>
            <span class="szk-mezo"><input type="text" class="kod" [(ngModel)]="s.msz_tol" [disabled]="s.msz_nelkul" list="szkMszLista" maxlength="10">
              <button type="button" class="szk-val" [disabled]="s.msz_nelkul" (click)="valasztoNyit('munkaszam', 'msz_tol')" title="Választás a munkaszám-törzsből"><ion-icon name="caret-forward"></ion-icon></button></span>
            <span class="kozep">–</span>
            <span class="szk-mezo"><input type="text" class="kod" [(ngModel)]="s.msz_ig" [disabled]="s.msz_nelkul" list="szkMszLista" maxlength="10">
              <button type="button" class="szk-val" [disabled]="s.msz_nelkul" (click)="valasztoNyit('munkaszam', 'msz_ig')" title="Választás a munkaszám-törzsből"><ion-icon name="caret-forward"></ion-icon></button></span>

            <span></span>
            <label class="szk-sor-jelolo"><input type="checkbox" [(ngModel)]="s.msz_nelkul" (ngModelChange)="igazit('msz_nelkul')">
              Csak a munkaszám nélküli tételek</label>
          </ng-container>

          <ng-container *ngIf="van('partner')">
            <span class="szk-elvalaszt">Partnerkód</span>
            <span class="szk-mezo szk-elvalaszt"><input type="number" class="kod" min="0" [(ngModel)]="s.partner_kod">
              <button type="button" class="szk-val" (click)="valasztoNyit('partner', 'partner_kod')" title="Választás a partnertörzsből"><ion-icon name="caret-forward"></ion-icon></button></span>
            <small class="szk-elvalaszt szk-pnev">{{ partnerNev(s.partner_kod) }}</small>

            <span>Partnernév</span>
            <span class="szk-mezo"><input type="text" [(ngModel)]="s.partner_nev" list="szkPartnerLista">
              <button type="button" class="szk-val" (click)="valasztoNyit('partner', 'partner_nev', 'nev')" title="Választás a partnertörzsből"><ion-icon name="caret-forward"></ion-icon></button></span>
            <span></span>
            <select [(ngModel)]="s.partner_nev_op"><option *ngFor="let o of illeszkedesek" [value]="o.v">{{ o.c }}</option></select>
          </ng-container>

          <ng-container *ngIf="van('deviza')">
            <span>Devizanem</span>
            <select [(ngModel)]="s.deviza">
              <option value="">Minden tétel</option>
              <option *ngFor="let d of devizanemek" [value]="d">{{ d }}</option>
            </select><span></span><span></span>
          </ng-container>
        </div>

        <datalist id="szkSzlaLista"><option *ngFor="let t of tukor" [value]="t.szamlaszam">{{ t.nev }}</option></datalist>
        <datalist id="szkMszLista"><option *ngFor="let m of munkaszamok" [value]="m.kod">{{ m.nev }}</option></datalist>
        <datalist id="szkPartnerLista"><option *ngFor="let p of partnerek" [value]="p.nev">{{ p.kod }}</option></datalist>

        <div class="szk-hiba" *ngIf="hiba">{{ hiba }}</div>
        <div class="sa-lab">
          <button type="button" class="ov-gomb fo" (click)="ok()"><ion-icon name="funnel"></ion-icon>Szűkít</button>
          <button type="button" class="ov-gomb" (click)="alaphelyzet()" title="Minden feltétel törlése">Alaphelyzet</button>
          <span class="spacer"></span>
          <button type="button" class="ov-gomb" (click)="bezar.emit()">Bezár</button>
        </div>
      </div>
    </div>

    <!-- A ▸ választó: kereshető lista a törzsből -->
    <ion-modal [isOpen]="!!valaszto" (didDismiss)="valaszto = null" cssClass="bevsor-modal">
      <ng-template>
        <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>{{ valasztoCim }}</ion-title></ion-toolbar></ion-header>
        <div class="bv-torzs szk-valaszto">
          <div class="n-szuro-sor">
            <input type="search" [(ngModel)]="valasztoKereso" placeholder="Keresés kódra, névre…" autofocus
                   (keydown.enter)="valasztoLista.length && valasztoValaszt(valasztoLista[0])">
            <span class="spacer"></span><span class="halvany">{{ valasztoLista.length }} db</span>
          </div>
          <div class="tabla-wrap">
            <table class="n-racs">
              <thead><tr><th style="width:120px">Kód</th><th>Megnevezés</th></tr></thead>
              <tbody>
                <tr *ngFor="let x of valasztoLista" class="kattinthato" [class.gyujto]="x.gyujto" (click)="valasztoValaszt(x)">
                  <td><b>{{ x.kod }}</b></td><td>{{ x.nev }}</td>
                </tr>
              </tbody>
            </table>
            <div class="ures" *ngIf="!valasztoLista.length">Nincs találat.</div>
          </div>
          <div class="sa-lab"><span class="spacer"></span><button type="button" class="ov-gomb" (click)="valaszto = null">Mégsem</button></div>
        </div>
      </ng-template>
    </ion-modal>
  </ng-template>
</ion-modal>
